import { JSX } from 'react';
import StyledText from '../../styles/StyledText';

interface TextProps {
  tag: string;
  text: string;
  color: string;
}

const Text = ({ tag, text, ...others }: TextProps): JSX.Element => {
  return (
    <StyledText as={tag} {...others}>{text}</StyledText>
  );
};

export default Text;